import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const TipList = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  font-size: 14px;
  margin-top: 24px;
  flex-wrap: wrap;
  gap: 24px;
`;

const Title = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export { TipList, Title };
